import styles from './menu-item-spacer.module.css';

/**
 * @public Component to display space between menu items.
 */
export function MenuItemSpacer() {
  return <li aria-hidden="true" className={styles.menuItemSpacer} />;
}
